import React from 'react'
import { BatsmanLite, BowlerLite } from '../../../common'

/**
 * Construct recent overs string
 * @param  {Array}  options.overs overs array (last 12 balls)
 * @return {String}               displayable string of last 12 balls. Each over
 *                                is separated by a pipe (|)
 */
const RecentOvers = ({
  overs = []
}) => {

  let recent = []

  overs.map((over = [], i) => {
    over.map((r) => {
      const isDot = r == '0'
      recent.push(`${isDot ? '.' : r}`)
    })
    // Add separator, If not last
    // TODO: use Array.reduce and refactor
    if(i !== overs.length-1) {
      recent.push(' | ')
    }
  })

  return (
    <tr className="cricinfo__table__tr">
      <td colSpan="2" className="cricinfo__table__td">
        <span className="cricinfo__type__weight--bold">Recent:</span> {recent.join(' ')}
      </td>
    </tr>
  )
}

/**
 * Innings summary component for live games.
 * Displays current batsmen, bowlers, partership details, last wicket etc.
 * @return {React.Element} Summary of live innings
 */
const InningsSummary = ({
  liteBatsmen = [],
  liteBowlers = [],
  heading = '',
  partnership = '',
  lastWicket = '',
  fow = '',
  recentOvers,
  sessionInfo = ''
}) => {

  if (liteBatsmen.length === 0 || liteBowlers.length === 0) {
    return (
      <div className="cricinfo__content__item">
        <h2 className="cricinfo__sub-title">{sessionInfo}</h2>
      </div>
    )
  }

  return (
    <div className="cricinfo__content__item">
      <h2 className="cricinfo__sub-title">{heading}</h2>
      <table className="cricinfo__table cricinfo__table--light">
        <thead>
          <tr className="cricinfo__table__tr">
            <th colSpan="2" className="cricinfo__table__th cricinfo__type__align--left">BATSMAN</th>
          </tr>
        </thead>
        <tbody>

        {
          liteBatsmen.map((batsman = { stats: [] }, i) => {
            return <BatsmanLite batsman={batsman} bId={i} showOutComms={false}/>
          })
        }

        <RecentOvers overs={recentOvers} />

        {
          partnership ?
          <tr className="cricinfo__table__tr">
            <td colSpan="2" className="cricinfo__table__td"><span className="cricinfo__type__weight--bold">Partnership:</span> {partnership}</td>
          </tr> : null
        }
        {
          lastWicket ?
          <tr className="cricinfo__table__tr">
            <td colSpan="2" className="cricinfo__table__td"><span className="cricinfo__type__weight--bold">Last W'ket:</span> {lastWicket}</td>
          </tr> : null
        }
        </tbody>
        <thead>
          <tr className="cricinfo__table__tr">
            <th colSpan="2" className="cricinfo__table__th cricinfo__type__align--left">BOWLERS</th>
          </tr>
        </thead>
        <tbody>

        {
          liteBowlers.map((bowler = { stats: [] }, i) => {
            return <BowlerLite bowler={bowler} bId={i}/>
          })
        }
        {
          fow ?
          <tr className="cricinfo__table__tr">
            <td colSpan="2" className="cricinfo__table__td"><span className="cricinfo__type__weight--bold">Fall of Wicket:</span> {fow}</td>
          </tr> : null
        }

        </tbody>
      </table>
    </div>
  )
}

export default InningsSummary



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/lite/InningsSummary.jsx
 **/